import React from 'react';
import { connect } from 'react-redux';
import { sessionSelectors } from './redux';
import { termsSelectors } from '../terms/redux';
import './RequireAuth.css';
import SessionMenuItemContainer from './SessionMenuItemContainer';
import Loading from '../../components/Loading';

const RequireAuth = ({ allowedRoles, children, checkingSession, loggedInUser, role, termsStatus }) => {
    if (checkingSession) {
        return <Loading title={'Kontrollerar session...'} />;
    }

    if (!loggedInUser) {
        return (
            <div className={'LoginInfo'}>
                <h3>Du behöver logga in för använda tjänsten.</h3>
                <SessionMenuItemContainer />
            </div>
        );
    }

    if (!role || !allowedRoles.includes(role)) {
        return <h3>Hoppsan din användare har inte rättighet att vara på den här sidan.</h3>;
    }

    if (!termsStatus || termsStatus.needsAcceptance) {
        return <Loading title={'Kontrollerar villkor...'} />;
    }

    return children;
};

const mapStateToProps = (state) => ({
    checkingSession: sessionSelectors.checkingSession(state),
    loggedInUser: sessionSelectors.loggedInUser(state),
    role: sessionSelectors.role(state),
    termsStatus: termsSelectors.status(state),
});

export default connect(mapStateToProps)(RequireAuth);
